/*
 * import.js - seo-admin
 * Copyright (c) CHECK24 Vergleichsportal Reise GmbH 2023.
 *
 * @author     Mark Kotsarev <mark.kotsarev@check24.de>
 * @modified   11.05.23, 16:27
 */

const widgetTeaser = document.querySelectorAll('.wt-Teaser');
window.fireOnVisible(widgetTeaser, async (teaserElem) => {
    const sliderElement = teaserElem.querySelector('.tcmsSlider');
    const sliderEnabled = sliderElement.dataset.sliderEnabled === 'true';

    await import('./assets/css/teaser.scss');

    if (sliderElement && sliderEnabled) {
        await import('../../assets/frontend/js/tcmsSlider/tcms_base_tcmsSlider.ts').then(({ TcmsSlider }) => {
            new TcmsSlider(sliderElement, {
                offset: 16,
                slidesPerView: 1.2,
                slideMinWidth: 312.5,
                breakpoints: {
                    740: {
                        navigation: true,
                        slidesPerView: 3,
                        slideMinWidth: 330
                    },
                    1025: {
                        offset: 0,
                        slidesPerView: 4,
                        slideMinWidth: 312.5
                    }
                }
            });
        });
    } else {
        await import('../../assets/frontend/styles/tcmsSlider/disabled.scss');
    }
});
